import { render, staticRenderFns } from "./ForgotPasswordSalon.vue?vue&type=template&id=c5e5eff0"
import script from "./ForgotPasswordSalon.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSalon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports